import { createContext, useContext } from "react";
import { MapEditorPropsState } from "./MapEditorContext.types";

export const MapEditorPropsContext = createContext<MapEditorPropsState | null>(
  null
);

export const useMapEditorProps = (): MapEditorPropsState => {
  const context = useContext(MapEditorPropsContext);
  if (!context) {
    throw new Error(
      "useMapEditorProps must be used within a MapEditorProvider"
    );
  }
  return context;
};
